import React, { useEffect } from 'react'
import { Form, Modal } from 'antd';
import PotionWikiForm from '../form/PotionWikiForm';

export default function PotionWikiModal({isModalVisible, setIsModalVisible, refresh, record}){
    const [form] = Form.useForm()

    function handleOk() {
        setIsModalVisible(false);
    }

    function handleCancel() {
        setIsModalVisible(false);
    }

    useEffect(() => {
        form.setFieldsValue(record)
        form.setFieldsValue({
            item: record?.item?.id,
        })
    },     //eslint-disable-next-line
    [form, record])

    return (
            <Modal 
                title={`Selected Potion : ${record?.item?.name}`}  
                visible={isModalVisible} 
                onOk={handleOk} 
                onCancel={handleCancel}
                footer={null}
                width={"80%"}
                
            >
                <PotionWikiForm 
                    form={form}
                    record={record}
                />
            </Modal>
    )
}